import { Message } from 'common/infrastructure/bus';
import { ICommand } from 'common/infrastructure/command.bus';
import { UpdateAssetCommand } from '@planitgeo/treeplotter-domain/lib/modules/asset-class/asset/domain/command/update-asset.command';
import FieldRepository from 'assetClass/infrastructure/field/repository';
import { eventBus } from 'common/infrastructure/event.bus';
import AssetRepository from 'assetClass/infrastructure/assetClass/asset/repository';

export const processCommand = async (command: Message<ICommand<UpdateAssetCommand>>) => {
  const { id: assetId, assetClassId, attributes, tp2AssetId } = command.data.payload.asset;

  const fields = await FieldRepository.getFields(assetClassId);

  const asset = await AssetRepository.getAsset(
    assetClassId,
    {
      id: assetId,
      tp2AssetId,
    },
    fields
  );

  asset.update(attributes);

  await AssetRepository.updateAssetLocalState(asset);

  eventBus.publish({
    type: 'AssetUpdatedEvent',
    payload: asset.update({
      ...attributes,
    }),
  });
};
